import { Controller } from '@hotwired/stimulus'
import { useResize, useThrottle } from 'stimulus-use'

export default class extends Controller {
  static targets = ['offsetSource', 'offsetTarget']
  static throttles = ['updateOffset']

  connect() {
    if (!this.hasTargets()) return

    useResize(this, {
      dispatchEvent: false,
      element: this.offsetSourceTarget
    })

    useThrottle(this, { wait: 100 })

    this.updateOffset()

    this.boundUpdateOffset = this.updateOffset.bind(this)
    window.addEventListener('scroll', this.boundUpdateOffset)
  }

  disconnect() {
    window.removeEventListener('scroll', this.boundUpdateOffset)
  }

  resize() {
    this.updateOffset()
  }

  hasTargets() {
    return this.hasOffsetSourceTarget && this.offsetTargetTargets.length > 0
  }

  updateOffset() {
    if (!this.hasTargets()) return

    const sourceRect = this.offsetSourceTarget.getBoundingClientRect()

    this.offsetTargetTargets.forEach(target => {
      const targetRect = target.getBoundingClientRect()

      // Add / Remove data-sticky conditionnally
      target.toggleAttribute('data-sticky', targetRect.top <= sourceRect.bottom)

      target.style.top = `${this.offsetSourceTarget.offsetHeight}px`
    })
  }
}
